import React from 'react';
import { Meta } from '../../../../styled components/Typography';
import ListViewChildBooking from '../ListViewChildBooking/ListViewChildBooking';
import ListViewSetToggle from '../../ListViewSetToggle/ListViewSetToggle';
import { ChildBookingList } from '../ListViewChildBooking/ListViewChildBooking.style';
import { CardChildren, CardChildrenSummary } from './ListViewCardChildren.style';
import type {
  ListViewBooking,
  ListViewDiff,
  ListViewSetCollapse,
  TimeFormatSetting
} from '../../../types';

interface ListViewCardChildrenProps {
  /* The set the card is of: its direct members are listed here, and a member
     that is a set itself lists its own members in turn */
  setBooking: ListViewBooking;
  setCollapse: ListViewSetCollapse;
  statusByID: ListViewDiff['statusByID'];
  timeFormatSetting: TimeFormatSetting;
}

/* The member bookings of a set, as a collapsible section of the set's card.
   Only the direct members are listed here; a member that is a set itself
   opens and closes on its own where it is listed. */
const ListViewCardChildren = ({
  setBooking,
  setCollapse,
  statusByID,
  timeFormatSetting
}: ListViewCardChildrenProps) => {
  const expanded = setCollapse.isSetExpanded(setBooking.id);
  return (
    <CardChildren>
      <CardChildrenSummary>
        <ListViewSetToggle
          expanded={expanded}
          onToggle={() => setCollapse.onToggleSet(setBooking.id)}
          setName={setBooking.resourceName}
        >
          <Meta $color="current" tw="ml-2">
            {i18n('Toggle resources in this set')}
          </Meta>
        </ListViewSetToggle>
      </CardChildrenSummary>
      {expanded && (
        <ChildBookingList>
          {setBooking.children.map((child) => (
            <ListViewChildBooking
              key={child.id}
              child={child}
              setCollapse={setCollapse}
              statusByID={statusByID}
              timeFormatSetting={timeFormatSetting}
            />
          ))}
        </ChildBookingList>
      )}
    </CardChildren>
  );
};

export default ListViewCardChildren;
